import axios from 'axios';
import L from 'leaflet';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet/dist/leaflet.css';
import { useEffect, useState } from 'react';
import { useCityLocation } from '../../contexts/CityLocationContext';
import { Location } from '../../utils/GeocoderUtility';
import './EventsSegment.css';

// Fix for default marker icon issue with Leaflet and Webpack
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

type BackgroundImage = {
  url: string;
  description: string;
}

function NewsSegment() {
  const [location] = useState<Location | null>(null);
  const { cityLocation } = useCityLocation();
  const [backgroundImage, setBackgroundImage] = useState<BackgroundImage | null>(null);

  // Fetch events when city location changes
  useEffect(() => {
    const fetchWeatherBackground = async () => {
      if (!cityLocation) return;

      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/weather/background`, {
          withCredentials: true,
          params: {
            location: cityLocation,
            forceUser: `${JSON.parse(process.env.REACT_APP_USER ? process.env.REACT_APP_USER : '')?.email}`,
          }
        });

        const weatherBackgroundImage = response.data.events_results || [];
        setBackgroundImage(weatherBackgroundImage);
      } catch (error) {
        console.error('Error fetching weather background image:', error);
      }
    };

    fetchWeatherBackground();
  }, [cityLocation]);

  return (
    <div className="Event">
      <main className="relative pt-12">
        {location ? (
          <>
            <img src={backgroundImage?.url} alt={backgroundImage?.description} className="absolute inset-0 object-cover w-full h-full" />
          </>
        ) : (
          <p>Loading location...</p>
        )}
      </main>
    </div>


  );
}

export default NewsSegment;